<template>
  <b-row>
    <b-col md="4">
      <label>Duración del contrato*</label>
    </b-col>
    <b-col md="8">
      <b-form-select :value="oferta.duracionContratoId" :disabled="disabled" @input="cambiarDuracionContrato">
        <b-form-select-option disabled selected value=""> Seleccione la duración del contrato </b-form-select-option>
        <b-form-select-option
          v-for="duracionContrato in duracionesContrato"
          :key="duracionContrato.id"
          :value="duracionContrato.id"
        >
          {{ duracionContrato.nombre }}
        </b-form-select-option>
      </b-form-select>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: mapState(useOfertaFormStore, ["oferta", "duracionContrato", "duracionesContrato"]),
  methods: {
    ...mapActions(useOfertaFormStore, ["cambiarDuracionContrato"]),
  },
};
</script>
